import React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, EffectCoverflow, Autoplay } from "swiper";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "../assets/styles/gallery.css";
import { useTranslation } from 'react-i18next';

const DEFAULT_IMAGE_KEYS = [
  { file: "letto1", category: "camere", key: "letto1" },
  { file: "letto2", category: "camere", key: "letto2" },
  { file: "letto3", category: "camere", key: "letto3" },
  { file: "letto4", category: "camere", key: "letto4" },
  { file: "camera1", category: "camere", key: "camera1" },
  { file: "bagno1", category: "bagni", key: "bagno1" },
  { file: "bagno2", category: "bagni", key: "bagno2" },
  { file: "bagno3", category: "bagni", key: "bagno3" },
  { file: "bagno4", category: "bagni", key: "bagno4" },
  { file: "cucina1", category: "cucina", key: "cucina1" },
  { file: "salone1", category: "salone", key: "salone1" },
  { file: "salone2", category: "salone", key: "salone2" },
  { file: "salone3", category: "salone", key: "salone3" },
  { file: "salone4", category: "salone", key: "salone4" },
  { file: "fuori1", category: "esterno", key: "fuori1" },
];

const SwiperComponent = ({ items }) => {
  const { t } = useTranslation();

  const slides = items || DEFAULT_IMAGE_KEYS.map((img) => ({
    ...img,
    label: t(`gallery.images.${img.key}.label`),
    desc: t(`gallery.images.${img.key}.desc`),
  }));

  return (
    <Swiper
      style={{ "--swiper-pagination-color": "#C9984E" }}
      effect="coverflow"
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      grabCursor={true}
      centeredSlides={true}
      slidesPerView="auto"
      coverflowEffect={{
        rotate: 20,
        stretch: 0,
        depth: 120,
        modifier: 1,
        slideShadows: true,
      }}
      pagination={{ clickable: true }}
      modules={[EffectCoverflow, Pagination, Autoplay]}
      className="mySwiper"
    >
      {slides.map((item, index) => (
        <SwiperSlide key={index}>
          <img
            src={require(`../assets/images/${item.file}.jpg`)}
            alt={item.label}
          />
          <div className="slide-overlay">
            <span className="slide-category">{item.category}</span>
            <h3 className="slide-label">{item.label}</h3>
            <p className="slide-desc">{item.desc}</p>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default SwiperComponent;
